/* Sika Design 3D generator: Choose model drawer (20 Oct 2026, Dee approved the mock-ups).
   The Model row (no arrow any more) opens a drawer with the other models of the same collection that have a 3D file,
   in tabs Seating / Lounges / Sofas & benches / Tables (a tab only shows when it has products). Each card shows a
   realistic preview rendered in the generator, in the colour group of the current frame
   (Files: 3d_preview_<handle>_<group slug>.jpg, e.g. 3d_preview_margret-dining-chair_cherry-rattan.jpg); when there is no
   preview the product photo is used. "See my model" opens the chosen model with the same materials
   (window.cpgModelLink -> ?product=<handle>&cfg=<record>, the share-link restore). Footstools are left out for now. */
(function () {
  var PV = 'v=20261020c';   /* 20 Oct 2026: previews are transparent PNGs now; the tile colour comes from .cpg-mod__img in CSS */
  var TABS = [['seating', 'Seating'], ['lounges', 'Lounges'], ['sofas', 'Sofas & benches'], ['tables', 'Tables']];
  function cat(p) {
    var t = ((p.type || '') + ' ' + (p.title || '')).toLowerCase();
    if (/foot\s*stool/.test(t)) return null;
    if (/lounge|rocking|sunbed|sun bed|daybed|day bed|hanging chair/.test(t)) return 'lounges';
    if (/sofa|bench/.test(t)) return 'sofas';
    if (/table/.test(t)) return 'tables';
    if (/chair|stool|seat/.test(t)) return 'seating';
    return 'seating';
  }
  function slug(s) { return String(s || '').toLowerCase().replace(/\s*\|\s*/g, '-').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    if (root.__cpgModels || typeof window.cpgModels !== 'function') return;
    var dr = document.querySelector('x-drawer.cpg-modeldrawer');
    if (!dr) return;
    root.__cpgModels = true;
    var body = dr.querySelector('[data-cpg-mod-body]'), apply = dr.querySelector('[data-cpg-mod-apply]');
    var st = { tab: null, pick: null };

    function card(p, cur, frame) {
      var src = '/cdn/shop/files/3d_preview_' + p.handle + '_' + slug(frame) + '.png?width=480&' + PV;
      var fb = p.img || '';
      return '<button type="button" class="cpg-mod__card' + (p.handle === st.pick ? ' is-picked' : '') + '" data-h="' + esc(p.handle) + '">' +
        '<span class="cpg-mod__img"><img loading="lazy" alt="' + esc(p.title + ' – 3D preview') + '" src="' + esc(src) + '"' +
        (fb ? ' onerror="this.onerror=null;this.src=\'' + esc(fb) + '\';this.parentNode.classList.add(\'is-photo\')"' : '') + '></span>' +
        '<span class="cpg-mod__name">' + esc(p.title) + '</span>' +
        (p.handle === cur ? '<span class="cpg-mod__cur">Current model</span>' : '') + '</button>';
    }
    function render() {
      var m = window.cpgModels(), groups = {};
      m.products.forEach(function (p) { var c = cat(p); if (c) (groups[c] = groups[c] || []).push(p); });
      var tabs = TABS.filter(function (t) { return groups[t[0]] && groups[t[0]].length; });
      if (!st.tab || !groups[st.tab]) {
        var curP = m.products.filter(function (p) { return p.handle === m.current; })[0];
        st.tab = (curP && cat(curP)) || (tabs[0] && tabs[0][0]);
      }
      var list = groups[st.tab] || [];
      body.innerHTML =
        '<div class="cpg-mod__tabs" role="tablist">' + tabs.map(function (t) {
          return '<button type="button" role="tab" class="cpg-mod__tab' + (t[0] === st.tab ? ' is-active' : '') + '" aria-selected="' + (t[0] === st.tab) + '" data-tab="' + t[0] + '">' + t[1] + '</button>';
        }).join('') + '</div>' +
        '<div class="cpg-mod__grid">' + list.map(function (p) { return card(p, m.current, m.frame); }).join('') + '</div>';
      apply.textContent = 'See my model';
    }
    function open() { st.pick = window.cpgModels().current; st.tab = null; render(); dr.show(); }
    body.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tab]');
      if (t) { st.tab = t.getAttribute('data-tab'); render(); return; }
      var c = e.target.closest('[data-h]');
      if (c) { st.pick = c.getAttribute('data-h'); body.querySelectorAll('.cpg-mod__card').forEach(function (x) { x.classList.toggle('is-picked', x === c); }); }
    });
    apply.addEventListener('click', function () {
      var m = window.cpgModels();
      if (!st.pick || st.pick === m.current) { dr.hide(); return; }
      apply.textContent = 'Loading…';
      location.href = window.cpgModelLink(st.pick);
    });

    /* the Model row opens the drawer instead of the dropdown (desktop and phone) */
    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-cpg-field="product"]');
      if (!f || !root.contains(f)) return;
      if (e.target.closest('.cpg__dd-list')) return;
      e.preventDefault(); e.stopPropagation();
      f.querySelectorAll('.cpg__dd.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      open();
    }, true);
    /* phone only (20 Oct 2026, Dee picked option C): swap icon + CHANGE on the MODEL label line; CSS hides it on desktop */
    var lab = root.querySelector('[data-cpg-field="product"] .cpg__label');
    if (lab && !lab.querySelector('.cpg-mod__chg')) {
      var chg = document.createElement('span');
      chg.className = 'cpg-mod__chg';
      chg.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M4 8h14l-4-4M20 16H6l4 4"/></svg><span>Change</span>';
      lab.appendChild(chg);
    }
    root.classList.add('cpg--models');
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.cpg'), function (r) { if (r.querySelector('model-viewer')) init(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
  setTimeout(boot, 1500);
})();
